import React from "react";
import SubHeroBanner from "./subHeroBanner";

const SubHeroFirst = () => {
  return (
    <div className="row">
        <div className="col-lg-6 col-12 pr-5">
            <div className="section-title mb-20">
                <h1>About Us</h1>
            </div>
            <p className="pr-lg-5 revamp-about-text">
                We are a forward-thinking technology hub dedicated to empowering innovators, nurturing talent, and building solutions that create real impact. Our experience spans technology, business, and product development, allowing us to bridge the gap between ideas and execution across different industries.
                <br /><br />
                <strong>Collaboration</strong><br />
                We believe in building strong, meaningful relationships. By working closely with individuals, startups, and organizations, we create solutions that are practical, scalable, and aligned with real needs. We don’t just work for you. We work with you to achieve lasting results.
                <br /><br />
                <strong>Creativity</strong><br />
                Innovation is at the heart of everything we do. We approach every challenge with creativity and a problem-solving mindset, transforming ideas into functional, impactful solutions that stand out in a rapidly evolving digital world.
                <br /><br />
                <strong>Excellence</strong><br />
                We are committed to delivering high-quality, reliable, and forward-looking solutions. From product development to enterprise systems and digital platforms, our focus is on consistency, performance, and long-term value.
            </p>
        </div>

        <SubHeroBanner />

    </div>
  );
}

export default SubHeroFirst;